// src/components/ErrorBoundary.js
import * as React from 'react';
import { useEffect } from 'react';
import { ErrorBoundary, FallbackProps } from 'react-error-boundary';
import { GetUserProfile } from '../../utilities/general';
import { ReportError } from '../../utilities/error-reporting';

export const logError = (error: Error, info: React.ErrorInfo) => {
  try {
    // You can send this to an error reporting service
    console.error('Error caught by boundary:', error);
    console.error('boundary: Component stack:', info.componentStack);

    ReportError({
      user: GetUserProfile(),
      errorLog: error.message,
      additionalPayload: {
        componentStack: info.componentStack,
        error: error,
        errorInfo: info,
      },
    });

    // {
    // 		project_name,
    // 		stack,
    // 		username,
    // 		timestamp,
    // 		severity_level,
    // 		page_url,
    // 		backend_endpoint,
    // 		error_log,
    // 		additional_payload,
    // 		user_token,
    // 	}

    // const blob = new Blob([JSON.stringify(errorData, null, 2)], { type: 'application/json' });
    // const url = URL.createObjectURL(blob);
    // const a = document.createElement('a');
    // a.href = url;
    // a.download = `error-log-${new Date().getTime()}.json`;
    // document.body.appendChild(a);
    // a.click();
    // document.body.removeChild(a);
    // URL.revokeObjectURL(url);
  } catch (error) {
    console.error('Error logging failed:', error);
  }
}

export const FallbackComponent = ({ error, resetErrorBoundary }: FallbackProps) => {

  return (
    <div role="alert" className="fixed inset-0 flex items-center justify-center bg-white">
      <div className="flex flex-col gap-4 p-8 bg-red-50 rounded-lg max-w-2xl w-full">
        <h2 className="text-2xl font-semibold text-red-600">Ooops, something went wrong</h2>
        <p className="text-black/90">Please try again or contact support if the problem persists.</p>
        {/* <div className="bg-white p-4 rounded">
          <pre className="whitespace-pre-wrap text-sm text-red-800 font-mono">{error.message}</pre>
        </div> */}
        <div className="flex justify-end gap-3">
          {/* <button 
            onClick={handleDownloadError}
            className="px-4 py-2 bg-gray-600 text-white rounded hover:bg-gray-700 transition-colors"
          >
            Download Error Info
          </button> */}
          <button
            onClick={resetErrorBoundary}
            className="px-4 py-2 bg-red-600 text-white rounded hover:bg-red-700 transition-colors"
          >
            Back to Home
          </button>
        </div>
      </div>
    </div>
  );
}

export const ErrorBoundaryWrapper = ({ children }: { children: React.ReactNode }) => (
  <ErrorBoundary
    FallbackComponent={FallbackComponent}
    onError={logError}
    onReset={() => {
      // Reset any state that might have caused the error
      window.location.href = '/';
    }}
  >
    {children}
  </ErrorBoundary>
);

